import Vue from 'vue';
import VueRouter from 'vue-router';
import type { RouteConfig } from 'vue-router';
import Index from '@/views/index.vue';
import NotFound from '@/views/not-found.vue';
import { isPromise } from '@/shared/util';
import LoginComponent from '@/views/login.vue';
import InformationComponent from '@/views/credit/information.vue';
import ContactsComponent from '@/views/credit/contacts.vue';
import IdMessageComponent from '@/views/credit/idMessage.vue';
import FaceComponent from '@/views/credit/face.vue';
import CollectSmsComponent from '@/views/credit/collect-sms.vue';
import ResultComponent from '@/views/result/index.vue';
import CloseAccountComponent from '@/views/misc/close-account.vue';
import RepayComponent from '@/views/repay/index.vue';
import RepayNoOrderComponent from '@/views/repay/no-order.vue';
import RepayPayment from '@/views/repay/payment.vue';
import AgreementComponent from '@/views/protocol/agreement.vue';
import RepaymentH5Component from '@/views/repayment/h5/index.vue';
import RepaymentH5ListComponent from '@/views/repayment/h5/list.vue';
import LandingComponent from '@/views/landingPage/index.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  /**
   * 404
   */
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/',
    name: 'index',
    meta: {
      excludeLogin: true,
      title: undefined,
      trackingPgName: '',
      excludeTracking: true,
      keepAlive: false,
    },
    component: Index,
  },
  {
    path: '/login',
    meta: {
      excludeLogin: true,
      title: undefined,
      trackingPgName: '',
      excludeTracking: true,
      keepAlive: false,
    },
    // component: () => import('@/views/login.vue'),
    component: LoginComponent,
  },
  {
    path: '/information',
    meta: {
      excludeLogin: true,
      title: 'Información básica',
      trackingPgName: 'personal_info_screen',
      excludeTracking: false,
      keepAlive: true,
    },
    // component: () => import('@/views/credit/information.vue'),
    component: InformationComponent,
  },
  {
    path: '/contacts',
    meta: {
      excludeLogin: true,
      title: 'Persona de contacto',
      trackingPgName: 'contact_info_screen',
      excludeTracking: false,
      keepAlive: true,
    },
    // component: () => import('@/views/credit/contacts.vue'),
    component: ContactsComponent,
  },

  {
    path: '/idMessage',
    name: 'IdMessage',
    meta: {
      excludeLogin: true,
      title: 'Autenticación ID',
      trackingPgName: 'id_info_screen',
      excludeTracking: false,
      keepAlive: true,
    },
    component: IdMessageComponent,
    // component: () => import('@/views/credit/idMessage.vue'),
  },
  {
    path: '/face',
    name: 'Face',
    meta: {
      excludeLogin: true,
      title: 'Reconocimiento facia',
      trackingPgName: 'liveness_auth_screen',
      excludeTracking: false,
      keepAlive: true,
    },
    component: FaceComponent,
    // component: () => import('@/views/credit/idMessage.vue'),
  },
  {
    path: '/collect-sms',
    name: 'CollectSms',
    meta: {
      excludeLogin: true,
      title: undefined,
      trackingPgName: '',
      excludeTracking: true,
      keepAlive: false,
    },
    component: CollectSmsComponent,
    // component: () => import('@/views/credit/collect-sms.vue'),
  },
  {
    path: '/result',
    meta: {
      excludeLogin: true,
      title: undefined,
      trackingPgName: 'underreview_auth_screen',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/result/index.vue'),
    component: ResultComponent,
  },
  {
    path: '/misc/close-account',
    meta: {
      excludeLogin: true,
      title: undefined,
      background: '#fff',
      trackingPgName: 'account_cancel_screen',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/misc/close-account.vue'),
    component: CloseAccountComponent,
  },
  {
    path: '/repay',
    meta: {
      excludeLogin: true,
      title: 'Reembolso',
      trackingPgName: 'details_repay_screen',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/repay/index.vue'),
    component: RepayComponent,
  },
  {
    path: '/repay/no-order',
    meta: {
      excludeLogin: true,
      title: 'Reembolso',
      trackingPgName: 'details_repay_screen',
      excludeTracking: true,
      keepAlive: false,
    },
    // component: () => import('@/views/repay/no-order.vue'),
    component: RepayNoOrderComponent,
  },
  {
    path: '/repay/payment',
    meta: {
      excludeLogin: true,
      title: 'Reembolsar mediante SPEI',
      trackingPgName: 'payment_screen',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/repay/payment.vue'),
    component: RepayPayment,
  },
  {
    path: '/repayment/h5',
    meta: {
      excludeLogin: true,
      title: '',
      trackingPgName: '',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/repayment/h5/index.vue'),
    component: RepaymentH5Component,
  },
  {
    path: '/repayment/h5/list',
    meta: {
      excludeLogin: true,
      title: '',
      trackingPgName: '',
      excludeTracking: false,
      keepAlive: false,
    },
    // component: () => import('@/views/repayment/h5/list.vue'),
    component: RepaymentH5ListComponent,
  },
  {
    path: '/protocol/agreement',
    meta: {
      excludeLogin: true,
      title: 'Condiciones',
      trackingPgName: '',
      background: '#fff',
      excludeTracking: true,
      keepAlive: false,
    },
    // component: () => import('@/views/protocol/agreement.vue'),
    component: AgreementComponent,
  },
  {
    path: '/landingPage',
    meta: {
      excludeLogin: true,
      title: '',
      trackingPgName: '',
      background: '#fff',
      excludeTracking: true,
      keepAlive: false,
    },
    // component: () => import('@/views/landingPage/index.vue'),
    component: LandingComponent,
  },
];

export function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PREFIX,
    routes,
    scrollBehavior() {
      return { y: 0, x: 0 };
    },
  });

  const originalPush = router.push;
  router.push = function push(...args: any) {
    const result = originalPush.apply(this, args);

    if (isPromise(result)) {
      return (result as any).catch((err: Error) => err);
    }
  };

  const originalReplace = router.replace;
  router.replace = function replace(...args: any) {
    const result = originalReplace.apply(this, args);

    if (isPromise(result)) {
      return (result as any).catch((err: Error) => err);
    }
  };

  return router;
}
